export default [
  {
    key: 'select', tdClass: 'text-center', thClass: 'col-nowrap',
  },
  {
    key: 'competencia', label: 'Competência', thClass: 'col-nowrap', sortable: true,
  },
  {
    key: 'rpa', label: 'RPA - Competência', thClass: 'col-header-wrap', sortable: true,
  },
  {
    key: 'rbt12', label: 'RBT12 - Doze meses anteriores', thClass: 'col-header-wrap', sortable: true,
  },
  {
    key: 'rba', label: 'RBA - Ano-calendário corrente', thClass: 'col-header-wrap', sortable: true,
  },
]
